// extracted by mini-css-extract-plugin
module.exports = {"container":"StepperTiers_container__P3mIa","steps":"StepperTiers_steps__FQROe","step":"StepperTiers_step__rvRNo","notCurrentStep":"StepperTiers_notCurrentStep__u2UXR"};